var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.component},[_c('v-btn',{attrs:{"color":"#E6B31D","width":"100%","dark":""},on:{"click":_vm.goToProfile}},[_vm._v(" My Profile ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }